export const nicheOptions = [
  "Todos",
  "Desarrollo personal",
  "Fitness",
  "Finanzas",
  "Marketing",
  "Tecnología",
  "Moda",
  "Gastronomía",
];

export const platformOptions = ["Todas", "Instagram", "Facebook", "TikTok", "YouTube", "LinkedIn"];

/**
 * Pipeline del socio: el recorrido completo de un contacto, desde que llega hasta que se vuelve socio.
 *   Nuevo → Contactado → Respondió → Presentación (ya tiene el enlace) → Webinar (se registró / lo está viendo)
 *   → Interesado (terminó el webinar o pidió avanzar) → Socio.
 * Además hay dos estados "fuera del camino": En seguimiento (pidió más tiempo) y No interesado.
 */
export const pipelineStages = [
  "Nuevo",
  "Contactado",
  "Respondió",
  "Presentación",
  "Webinar",
  "Interesado",
  "Socio",
];

export const sideStages = ["Seguimiento", "No interesado"];

export const stageHints: Record<string, string> = {
  Nuevo: "Llegó a tu lista, aún sin escribirle",
  Contactado: "Ya le enviaste el primer mensaje",
  "Respondió": "Te contestó: hay conversación",
  "Presentación": "Ya tiene tu enlace del webinar",
  Webinar: "Se registró o está viendo el webinar",
  Interesado: "Terminó el webinar o quiere avanzar",
  Socio: "Se unió como socio",
  Seguimiento: "Pidió más tiempo: vuelve a escribirle",
  "No interesado": "Pidió no recibir más mensajes",
};

export const statusOptions = ["Todos", ...pipelineStages, ...sideStages];

export const scoreOptions = ["Todos", "80+", "65 - 79", "50 - 64", "Menos de 50"];

export const followerOptions = ["Todos", "5K - 15K", "15K - 30K", "30K - 50K"];

export const prospects = [
  {
    id: "p1",
    name: "Camila Torres",
    photo: "https://readdy.ai/api/search-image?query=portrait%20photo%20of%20a%20confident%20young%20latina%20entrepreneur%20woman%20smiling%20warmly%2C%20casual%20smart%20outfit%2C%20clean%20soft%20neutral%20studio%20background%2C%20professional%20social%20media%20headshot%2C%20natural%20warm%20lighting&width=240&height=240&seq=vivelo-prospect-camila&orientation=squarish",
    username: "@cami.torres",
    platform: "Instagram",
    followers: 28500,
    niche: "Desarrollo personal",
    reason: "Audiencia muy afín a tu contenido de crecimiento personal y alta interacción en reels de hábitos.",
    score: 95,
    status: "Contactado",
    nextAction: "Generar y aprobar opener",
    followUp: "HOY",
  },
  {
    id: "p2",
    name: "Mariana Castillo",
    photo: "https://readdy.ai/api/search-image?query=portrait%20photo%20of%20a%20friendly%20latina%20lifestyle%20creator%20woman%20with%20long%20hair%20smiling%2C%20soft%20natural%20light%2C%20clean%20beige%20background%2C%20professional%20social%20media%20headshot%2C%20warm%20editorial%20style&width=240&height=240&seq=vivelo-prospect-mariana&orientation=squarish",
    username: "@mariana.vive",
    platform: "YouTube",
    followers: 35600,
    niche: "Desarrollo personal",
    reason: "Coincide con tu público objetivo y ya promociona cursos de mentalidad en su canal.",
    score: 94,
    status: "Socio",
    nextAction: "Cerrar colaboración",
    followUp: "En 2 días",
  },
  {
    id: "p3",
    name: "Valentina Ríos",
    photo: "https://readdy.ai/api/search-image?query=portrait%20photo%20of%20an%20athletic%20young%20latina%20fitness%20coach%20woman%20smiling%20confident%2C%20sporty%20outfit%2C%20clean%20light%20gray%20studio%20background%2C%20professional%20social%20media%20headshot%2C%20bright%20natural%20lighting&width=240&height=240&seq=vivelo-prospect-valentina&orientation=squarish",
    username: "@vale.rios.fit",
    platform: "Instagram",
    followers: 18400,
    niche: "Fitness",
    reason: "Comunidad activa que consume contenido de disciplina y hábitos, ideal para tu programa.",
    score: 92,
    status: "Nuevo",
    nextAction: "Analizar perfil y generar opener",
    followUp: "HOY",
  },
  {
    id: "p4",
    name: "Sofía Mendoza",
    photo: "https://readdy.ai/api/search-image?query=portrait%20photo%20of%20an%20elegant%20young%20latina%20finance%20educator%20woman%20with%20glasses%20smiling%2C%20smart%20blazer%2C%20clean%20white%20studio%20background%2C%20professional%20social%20media%20headshot%2C%20soft%20natural%20lighting&width=240&height=240&seq=vivelo-prospect-sofia&orientation=squarish",
    username: "@sofi.finanzas",
    platform: "Instagram",
    followers: 41200,
    niche: "Finanzas",
    reason: "Enseña finanzas personales a un público joven que busca monetizar habilidades digitales.",
    score: 90,
    status: "Interesado",
    nextAction: "Enviar presentación y agenda",
    followUp: "MAÑANA",
  },
  {
    id: "p5",
    name: "Andrés Salazar",
    photo: "https://readdy.ai/api/search-image?query=portrait%20photo%20of%20a%20young%20latino%20male%20marketing%20coach%20smiling%20confidently%2C%20casual%20shirt%2C%20clean%20neutral%20gray%20background%2C%20professional%20social%20media%20headshot%2C%20soft%20studio%20lighting&width=240&height=240&seq=vivelo-prospect-andres&orientation=squarish",
    username: "@andres.coach",
    platform: "TikTok",
    followers: 32400,
    niche: "Marketing",
    reason: "Genera alto tráfico con tips de marketing y podría recomendar tu ecosistema.",
    score: 88,
    status: "Contactado",
    nextAction: "Esperando respuesta",
    followUp: "MAÑANA",
  },
  {
    id: "p6",
    name: "Mateo Ramírez",
    photo: "https://readdy.ai/api/search-image?query=portrait%20photo%20of%20a%20young%20latino%20male%20technology%20creator%20with%20headphones%20around%20neck%20smiling%2C%20casual%20t-shirt%2C%20clean%20light%20background%2C%20professional%20social%20media%20headshot%2C%20modern%20lighting&width=240&height=240&seq=vivelo-prospect-mateo&orientation=squarish",
    username: "@mateo.dev",
    platform: "YouTube",
    followers: 12800,
    niche: "Tecnología",
    reason: "Público interesado en IA y productividad, encaja con tus módulos de inteligencia artificial.",
    score: 84,
    status: "Nuevo",
    nextAction: "Revisar contenido y calificar",
    followUp: "HOY",
  },
  {
    id: "p7",
    name: "Isabella Vargas",
    photo: "https://readdy.ai/api/search-image?query=portrait%20photo%20of%20a%20stylish%20young%20latina%20fashion%20influencer%20woman%20smiling%2C%20trendy%20outfit%2C%20clean%20pastel%20studio%20background%2C%20professional%20social%20media%20headshot%2C%20soft%20glam%20lighting&width=240&height=240&seq=vivelo-prospect-isabella&orientation=squarish",
    username: "@isa.vargas",
    platform: "Instagram",
    followers: 47800,
    niche: "Moda",
    reason: "Audiencia femenina joven receptiva a contenido de autoestima y marca personal.",
    score: 79,
    status: "Seguimiento",
    nextAction: "Reactivar conversación",
    followUp: "Vie 15",
  },
  {
    id: "p8",
    name: "Lucas Fernández",
    photo: "https://readdy.ai/api/search-image?query=portrait%20photo%20of%20a%20young%20latino%20male%20entrepreneur%20smiling%20energetic%2C%20casual%20hoodie%2C%20clean%20light%20background%2C%20professional%20social%20media%20headshot%2C%20natural%20lighting&width=240&height=240&seq=vivelo-prospect-lucas&orientation=squarish",
    username: "@lucas.emprende",
    platform: "TikTok",
    followers: 9600,
    niche: "Marketing",
    reason: "Creador emergente con excelente engagement y audiencia en crecimiento acelerado.",
    score: 81,
    status: "Respondió",
    nextAction: "Aprobar opener de seguimiento",
    followUp: "HOY",
  },
  {
    id: "p9",
    name: "Daniela Ortiz",
    photo: "https://readdy.ai/api/search-image?query=portrait%20photo%20of%20a%20professional%20latina%20businesswoman%20in%20her%20thirties%20smiling%2C%20formal%20blazer%2C%20clean%20navy%20studio%20background%2C%20professional%20social%20media%20headshot%2C%20corporate%20soft%20lighting&width=240&height=240&seq=vivelo-prospect-daniela&orientation=squarish",
    username: "@daniela-ortiz",
    platform: "LinkedIn",
    followers: 5400,
    niche: "Finanzas",
    reason: "Perfil profesional con audiencia B2B que valora formación y liderazgo.",
    score: 76,
    status: "Presentación",
    nextAction: "Agendar llamada de descubrimiento",
    followUp: "En 3 días",
  },
  {
    id: "p10",
    name: "Sebastián Rojas",
    photo: "https://readdy.ai/api/search-image?query=portrait%20photo%20of%20a%20cheerful%20young%20latino%20chef%20man%20smiling%2C%20white%20chef%20apron%2C%20clean%20warm%20neutral%20background%2C%20professional%20social%20media%20headshot%2C%20appetizing%20warm%20lighting&width=240&height=240&seq=vivelo-prospect-sebastian&orientation=squarish",
    username: "@seba.gastro",
    platform: "Instagram",
    followers: 22100,
    niche: "Gastronomía",
    reason: "Emprendedor gastronómico que busca escalar su marca personal y su negocio.",
    score: 83,
    status: "Nuevo",
    nextAction: "Generar primer contacto",
    followUp: "HOY",
  },
];

export const attentionItems = [
  {
    id: "a1",
    name: "Camila Torres",
    photo: "https://readdy.ai/api/search-image?query=portrait%20photo%20of%20a%20confident%20young%20latina%20entrepreneur%20woman%20smiling%20warmly%2C%20casual%20smart%20outfit%2C%20clean%20soft%20neutral%20studio%20background%2C%20professional%20social%20media%20headshot%2C%20natural%20warm%20lighting&width=120&height=120&seq=vivelo-prospect-camila&orientation=squarish",
    action: "Generar y aprobar opener",
    when: "HOY",
    tone: "urgent",
  },
  {
    id: "a2",
    name: "Andrés Salazar",
    photo: "https://readdy.ai/api/search-image?query=portrait%20photo%20of%20a%20young%20latino%20male%20marketing%20coach%20smiling%20confidently%2C%20casual%20shirt%2C%20clean%20neutral%20gray%20background%2C%20professional%20social%20media%20headshot%2C%20soft%20studio%20lighting&width=120&height=120&seq=vivelo-prospect-andres&orientation=squarish",
    action: "Esperando respuesta · Revisar",
    when: "MAÑANA",
    tone: "soon",
  },
  {
    id: "a3",
    name: "Lucas Fernández",
    photo: "https://readdy.ai/api/search-image?query=portrait%20photo%20of%20a%20young%20latino%20male%20entrepreneur%20smiling%20energetic%2C%20casual%20hoodie%2C%20clean%20light%20background%2C%20professional%20social%20media%20headshot%2C%20natural%20lighting&width=120&height=120&seq=vivelo-prospect-lucas&orientation=squarish",
    action: "Aprobar opener de seguimiento",
    when: "HOY",
    tone: "urgent",
  },
];